import { render, staticRenderFns } from "./CardBox.vue?vue&type=template&id=a4d8e2ea&scoped=true&"
import script from "./CardBox.vue?vue&type=script&lang=js&"
export * from "./CardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d8e2ea",
  null
  
)

export default component.exports